import PropTypes from 'prop-types';
import { ToggleWrapper, ToggleSwitch, ToggleSlider } from './Toggle.style';

const Toggle = ({ isActive, onClick, isEnabled = true }) => (
  <ToggleWrapper isEnabled={isEnabled} onClick={isEnabled ? onClick : undefined}>
    <ToggleSwitch isActive={isActive}>
      <ToggleSlider isActive={isActive} />
    </ToggleSwitch>
  </ToggleWrapper>
);

Toggle.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  isEnabled: PropTypes.bool,
};

Toggle.defaultProps = {
  onClick: () => {},
  isEnabled: true,
};

export default Toggle;
